/**
 * The referral login link
 * @type {string}
 */
export const LOGIN_URL = '/login?source=referral_program';

const TERMS_AND_CONDITIONS_LINK = '/cp/referral-program-terms-and-conditions';

/**
 * Terms and conditions links map
 * @type {object}
 */
export const TERMS_AND_CONDITIONS_LINKS = {
    GUEST_HEADER: `${TERMS_AND_CONDITIONS_LINK}?source=referral_program_invitation_header_lo`,
    GUEST_STEPS: `${TERMS_AND_CONDITIONS_LINK}?source=referral_program_invitation_steps_lo`,
    USER_HEADER: `${TERMS_AND_CONDITIONS_LINK}?source=referral_program_invitation_header_li`,
    USER_STEPS: `${TERMS_AND_CONDITIONS_LINK}?source=referral_program_invitation_steps_li`,
};

const AFFILIATE_LINK = 'https://affiliates.fiverr.com/';

/**
 * The affiliate links map
 * @type {string}
 */
export const AFFILIATE_LINKS = {
    USER: `${AFFILIATE_LINK}?source=referral_page_invitation_li`,
    GUEST: `${AFFILIATE_LINK}?source=referral_page_invitation_lo`,
};

/**
 * The invite bonus for your friend
 * @type {string}
 */
export const FRIENDS_BONUS = '10%';

/**
 * The invite bonus maximum amount (in USD)
 * @type {string}
 */
export const INVITE_MAX_BONUS = 500;

/**
 * The invite bonus maximum amount per referral (in USD)
 * @type {string}
 */
export const INVITE_MAX_BONUS_PER_REFERRAL = 100;

/**
 * The default currency used in the package.
 * @type {string}
 */
export const DEFAULT_CURRENCY = 'USD';

/**
 * The referral program rollouts
 * @type {object}
 */
export const ROLLOUTS = {} as const;

/**
 * The referral program experiments
 * @type {object}
 */
export const EXPERIMENTS = {} as const;
